import React from "react";
import classNames from "classnames";

import "./speedSign.css";

export default function SpeedSign(props) {
  const className = classNames("speedSign", {
    threeDigit: props.speedLimit >= 100,
  });
  return props.loading ? (
    <div>Loading Data...</div>
  ) : (
    <div className={className}>
      <div>{props.speedLimit || 0}</div>
    </div>
  );
}
